<div class="container py-4">
  <div class="card">
    <div class="rep-card-header">
      <i class="bi bi-building me-2"></i>
      {{ (isNew ? 'admin.clients.title_new' : 'admin.clients.title_edit') | translate }}
    </div>
    <div class="card-body">
      <form *ngIf="client" ngNativeValidate (ngSubmit)="save()">
        <fieldset [disabled]="disabled" class="border-0 p-0 m-0">
        <!-- Základní údaje -->
        <h5 class="section-title"><i class="bi bi-info-circle me-2"></i>{{ 'admin.clients.basic_info' | translate }}</h5>

        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label">{{ 'admin.clients.company_name' | translate }} *</label>
            <s-input type="text" name="name" [(model)]="client.name" [required]="true"></s-input>
          </div>
          <div class="col-md-3">
            <label class="form-label">{{ 'admin.clients.ico' | translate }}</label>
            <s-input type="text" name="ico" [(model)]="client.ico"></s-input>
          </div>
          <div class="col-md-3">
            <label class="form-label">{{ 'admin.clients.dic' | translate }}</label>
            <s-input type="text" name="dic" [(model)]="client.dic"></s-input>
          </div>
        </div>

        <!-- Adresa -->
        <h5 class="section-title mt-4"><i class="bi bi-geo-alt me-2"></i>{{ 'admin.clients.address' | translate }}</h5>

        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label">{{ 'admin.clients.street' | translate }}</label>
            <s-input type="text" name="street" [(model)]="client.street"></s-input>
          </div>
          <div class="col-md-4">
            <label class="form-label">{{ 'admin.clients.city' | translate }}</label>
            <s-input type="text" name="city" [(model)]="client.city"></s-input>
          </div>
          <div class="col-md-2">
            <label class="form-label">{{ 'admin.clients.zip' | translate }}</label>
            <s-input type="text" name="zip" [(model)]="client.zip"></s-input>
          </div>
        </div>

        <!-- Kontaktní osoba -->
        <h5 class="section-title mt-4"><i class="bi bi-person me-2"></i>{{ 'admin.clients.contact_person' | translate }}</h5>

        <div class="row mb-3">
          <div class="col-md-4">
            <label class="form-label">{{ 'admin.clients.contact_name' | translate }}</label>
            <s-input type="text" name="contact_name" [(model)]="client.contact_name"></s-input>
          </div>
          <div class="col-md-4">
            <label class="form-label">{{ 'admin.clients.contact_email' | translate }}</label>
            <s-input type="email" name="contact_email" [(model)]="client.contact_email"></s-input>
          </div>
          <div class="col-md-4">
            <label class="form-label">{{ 'admin.clients.contact_phone' | translate }}</label>
            <s-input type="text" name="contact_phone" [(model)]="client.contact_phone"></s-input>
          </div>
        </div>

        <!-- Poznámka -->
        <div class="mb-3">
          <label class="form-label">{{ 'admin.clients.notes' | translate }}</label>
          <s-input type="textarea" name="notes" [(model)]="client.notes"></s-input>
        </div>

        </fieldset>

        <!-- Uživatelé této firmy (jen u existujícího klienta) -->
        <div class="mt-4" *ngIf="!isNew">
          <h5 class="section-title">
            <i class="bi bi-people me-2"></i>{{ 'admin.clients.users' | translate }}
            <small class="text-muted ms-2">({{ users.length }})</small>
            <button type="button" class="btn btn-outline-success btn-sm ms-3"
              [disabled]="disabled" (click)="addUser()">
              <i class="bi bi-plus me-1"></i>{{ 'admin.clients.add_user' | translate }}
            </button>
          </h5>
          <div *ngIf="users.length === 0" class="text-muted small">
            {{ 'admin.clients.no_users' | translate }}
          </div>
          <table class="table table-hover" *ngIf="users.length > 0">
            <thead>
              <tr>
                <th>{{ 'cols.fullname' | translate }}</th>
                <th>{{ 'cols.username' | translate }}</th>
                <th>{{ 'cols.email' | translate }}</th>
                <th>{{ 'cols.active' | translate }}</th>
                <th>{{ 'cols.email_verified_at' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let u of users" class="cursor" (click)="openUser(u.id_user)">
                <td>{{ u.fullname }}</td>
                <td>{{ u.username }}</td>
                <td>{{ u.email }}</td>
                <td>{{ (u.active ? 'yes' : 'no') | translate }}</td>
                <td>{{ u.email_verified_at ? ((u.email_verified_at | date:'short')) : '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Akce -->
        <div class="form-actions">
          <div>
            <button type="button" class="btn btn-outline-primary" (click)="goBack()">
              <i class="bi bi-arrow-left me-2"></i>{{ 'back' | translate }}
            </button>
            <button type="button" class="btn btn-outline-danger ms-2" *ngIf="!isNew"
              [disabled]="disabled" (click)="delete()">
              <i class="bi bi-trash me-2"></i>{{ 'delete' | translate }}
            </button>
          </div>
          <button type="submit" class="btn btn-accent" [disabled]="disabled">
            <i class="bi bi-save me-2"></i>{{ 'save' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
